import React, { useState } from 'react';
import cn from 'classnames';
import CertificationBadge from 'components/CertificationBadge';
import BadgesModal from 'components/Learn/Header/BadgesModal';
import useFetch from 'components/shared/hooks/useFetch';
import { routes as ROUTES } from 'constants/config';
import DateFormat from 'constants/date_format';

const BADGE_LIMIT = 5;

const UserCompletedCertifications = ({ user }) => {
  const [showModal, setShowModal] = useState(false);

  const { data = {} } = useFetch(ROUTES.COMPLETED_CERTIFICATIONS(user.id));
  const { completed_certifications: completedCertifications } = data;
  const hasBadges =
    completedCertifications && completedCertifications.length > 0;

  const sortedCompletedCertifications = _.sortBy(completedCertifications, [
    'expired',
  ]);

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      {hasBadges && (
        <section className="Module TrainingEventSummary pb-16">
          <header>
            <h3 className="Module-heading SectionHeading">
              {t('certifications.certifications')}
            </h3>
          </header>
          <table className="Module--bordered">
            <thead>
              <tr>
                <th className="pl-20 w-45p">
                  {t('certifications.most_recent')}
                </th>
                <th className="ta-c pl-20">
                  {t('certifications.completion_date')}
                </th>
                <th className="ta-c pl-20">
                  {t(
                    'certifications.learner_overview.learners_modal.status_column_title',
                  )}
                </th>
              </tr>
            </thead>
            <tbody className="u-sans">
              {sortedCompletedCertifications
                .slice(0, BADGE_LIMIT)
                .map(certification => (
                  <tr key={certification.id}>
                    <td className="TrainingEventSummary-table-cell">
                      <div className="mw-450 d-f ai-c">
                        <div
                          className={cn('d-f mr-16', {
                            Expired: certification.expired,
                          })}
                        >
                          <CertificationBadge
                            width={26}
                            height={24}
                            iconName={certification.badge.iconName}
                            foregroundColor={
                              certification.badge.foregroundColor
                            }
                            backgroundColor={
                              certification.badge.backgroundColor
                            }
                            image={certification.badge.image}
                          />
                        </div>
                        <span className="BadgesModalCertificationTitle fz-16 w-fill wb-ba">
                          {certification.path.title}
                        </span>
                      </div>
                    </td>
                    <td className="ta-c pl-20">
                      <span className="fz-14">
                        {`${moment(certification.completedDate).format(
                          DateFormat.LONG,
                        )}`}
                      </span>
                    </td>
                    <td className="ta-c pl-20">
                      <span className="fz-14">
                        {certification.expired
                          ? `${t('certifications.certificate.expired_on')} ${
                              certification.expirationDate &&
                              moment(certification.expirationDate).format(
                                DateFormat.LONG,
                              )
                            }`
                          : t('certifications.status.active')}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {completedCertifications.length > BADGE_LIMIT && (
            <div className="d-f ai-c py-16 pr-20 jc-e h-40">
              <button
                className="u-linkBtn ff-ss fz-16 c-brand-blue"
                type="button"
                onClick={toggleModal}
              >
                {t('certifications.view_all')}
              </button>
              {showModal && (
                <BadgesModal
                  closeModal={toggleModal}
                  certifications={sortedCompletedCertifications}
                />
              )}
            </div>
          )}
        </section>
      )}
    </>
  );
};

export default UserCompletedCertifications;
